import React from "react";

import {
  chatLinks,
  callLink,
  chatLink,
  clientAccess,
} from "./ChooseProductSection.constants";

export const ResidentialList = [
  {
    id: 1,
    title: "Assistência e sinistro (cobertura)",
    description: (
      <>
        <strong>Solicite ou acompanhe:</strong> <br />{" "}
        <strong>Assistências</strong> - serviços de chaveiro, encanador,
        eletricista, entre outros, para imprevistos do dia a dia. <br />
        <strong>Sinistro</strong> - situações previstas no contrato, como
        alagamento e explosão, que causem danos ao lar.
      </>
    ),
    links: [
      {
        ...chatLink(chatLinks.residencial.assistencia),
        id: "1-link",
        description: (
          <>
            Converse com um de nossos especialistas.
            <br />
            <strong>Sinistro:</strong> de segunda a sexta, das 8h às 19h, exceto
            feriados nacionais.
            <br /> <strong>Assistências:</strong> atendimento 24 horas, todos os
            dias da semana, incluindo feriados nacionais.
          </>
        ),
      },
      {
        ...callLink,
        id: "2-link",
        description: (
          <>
            <strong>Sinistro:</strong> De segunda a sexta, das 8h às 19h, exceto
            feriados nacionais.
            <br /> <strong>Assistências:</strong> 24 horas por dia, todos os
            dias da semana, incluindo feriados nacionais.
          </>
        ),
      },
    ],
  },
  {
    id: 2,
    title: "Serviços e informações",
    description: (
      <>
        Informações sobre coberturas e assistências, alteração do seguro, 2ª via
        de boletos e documentos, cancelamento (apenas telefone), etc.
      </>
    ),
    links: [
      {
        ...chatLink(chatLinks.residencial.servico),
        id: "1-link",
        description:
          "Converse com um de nossos especialistas. De segunda a sexta, das 8h às 21h. Sábados, domingos e feriados, das 9h às 17h.",
      },
      {
        ...clientAccess,
        id: "2-link",
      },
      {
        ...callLink,
        id: "3-link",
        description:
          "De segunda a sexta, das 8h às 21h, exceto feriados nacionais.",
      },
    ],
  },
];
